module.exports = __webpack_public_path__ + "img/5.c0384721.png";